import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ToggleWrapper, ToggleLabel, ToggleInput, ToggleInner } from './styles';

class ToggleButton extends Component {
  toggleHighlights = (checked) => {
    this.props.actions.toggleHighlights(checked);
  };

  render() {
    const { checked } = this.props;
    return (
      <ToggleWrapper>
        <ToggleLabel>
          <ToggleInput
            type="checkbox"
            defaultChecked={checked}
            onClick={() => this.toggleHighlights(checked)}
          />
          <ToggleInner />
        </ToggleLabel>
      </ToggleWrapper>
    );
  }
}

ToggleButton.propTypes = {
  checked: PropTypes.bool,
  actions: PropTypes.any,
};

export default ToggleButton;



// WEBPACK FOOTER //
// ./src/components/shared/ToggleButton/index.js